import { StyleSheet } from 'react-native';

import Theme from 'Theme';
import { Device } from 'DeviceUtils';

const baseStyles = {
    textsContainer: {
        position: 'absolute',
        bottom: '6%',
        right: 0,
        left: 0,
        paddingHorizontal: '8%',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column'
    },
    textsContainerWithButton: {
        position: 'absolute',
        bottom: '3%',
        right: 0,
        left: 0,
        paddingHorizontal: '8%',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column'
    },
    title: {
        fontSize: 34,
        color: Theme.primaryTextColor,
        fontFamily: Theme.ultraFont,
        textAlign: 'center'
    },
    button: {
        alignSelf: 'center',
        width: '100%'
    },
    imageBackground: {
        ...StyleSheet.absoluteFill
    },
    paginationContainer: {
        position: 'absolute',
        bottom: '1%',
        left: 0,
        right: 0,
        paddingHorizontal: '50%'
    },
    paginationDotContainer: {
        alignItems: 'center'
    },
    dotStyle: {
        width: 9,
        height: 9,
        borderRadius: 100
    },
    closeIcon: {
        position: 'absolute',
        top: Device.isIos ? '5%' : 10,
        right: '3%'
    }
};

if (Device.isTablet) {
    baseStyles.button.width = Theme.BU * 20;
    baseStyles.textsContainer.paddingHorizontal = '18%';
    baseStyles.title.fontSize = 40;
}

export default StyleSheet.create(baseStyles);
